import Caller from "../../domain/Api/Caller";
import envVariable from "../../presentation/util/envVariable";
import FolderGatewayInterface from "../../domain/Folder/FolderGatewayInterface";
import {Folder, FolderDetail} from "../../domain/Folder/Folder";
import storage from "../../presentation/util/storage";
import PairingInterface from "../../domain/Folder/PairingInterface";
import { Pairing } from "../../domain/Folder/Pairing";
import InvalidElement from "../../domain/Folder/InvalidElementInterface";
import { getFolderIdFromUrl } from "../../infrastructure/hooks";

export default class FetchFolderGateway implements FolderGatewayInterface {
    async createFolder(formId: string, clientId: number): Promise<Folder | null> {

        return Caller.executePost(`${envVariable('REACT_APP_API_URL')}/dossiers`, {
            formId: formId,
            clientId: clientId,
            submittingBlockId: null,
            values: []
        })
            .then(response => {
                if (!response.dossier) {
                    return null
                }

                return new Folder(
                    response.dossier.id,
                    response.dossier.form_id,
                    response.dossier.client_id,
                    response.dossier.advisor_id,
                    response.dossier.last_submitted_block_id,
                    response.dossier.values,
                    response.dossier.direct,
                    response.dossier.receipts,
                    response.dossier.authorized_clients
                )
            })
    }

    async updateFolder(data: Array<string>, BlockId: string, productCode: string, folderId?: string): Promise<Folder | null> {
        const effectiveFolderId = folderId ?? getFolderIdFromUrl() ?? storage.getFolderId();
        const values = Object.entries(data).map((value) => {
            if (value) {
                return ({
                    elementId: value[0],
                    value: typeof value[1] === 'boolean' ? String(value[1]) : value[1]
                })
            }
        })

        return Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/${effectiveFolderId}/values`, {
            submittingBlockId: BlockId,
            productCode: productCode,
            values: values
        })
            .then(response => {
                if (response === undefined) {
                    return null
                }

                return new Folder(
                    response.dossier.id,
                    response.dossier.form_id,
                    response.dossier.client_id,
                    response.dossier.advisor_id,
                    response.dossier.last_submitted_block_id,
                    response.dossier.values,
                    response.dossier.direct,
                    response.dossier.receipts,
                    response.dossier.authorized_clients,
                    response.dossier.status
                )
            })
    }

    async getFolders(
      currentPage: number,
      itemPerPage: number,
      state: string|null,
      searchTerm: string|null,
      selectedForm: string|null,
      sortKey: string,
      sortDirection: string
    ): Promise<{dossiers: FolderDetail[]|null, totalItems: number}> {
        const params = {
          page: currentPage.toString(),
          itemsPerPage: itemPerPage.toString(),
          state: state !== null ? state : '',
          searchTerm: searchTerm !== null ? searchTerm : '',
          form: selectedForm !== null ? selectedForm : '',
          sortField: sortKey === 'date' ? 'created_at' : sortKey,
          sortDirection,
        }

        return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers`, params)
            .then(data => {

                if (!data) {
                    return {dossiers: null, totalItems: 0}
                }

              return {
                dossiers: (data.dossiers).map((dossier) => {
                  return new FolderDetail(
                    dossier.id,
                    dossier.creation_date,
                    dossier.validation_date,
                    dossier.signature_date,
                    dossier.status,
                    dossier.client,
                    dossier.detail,
                    dossier.advisor,
                    dossier.present ?? '',
                    dossier.subscriptionGlobalAmount ?? '',
                    dossier.np_amount ?? null,
                    dossier.usu_amount ?? null,
                    dossier.integrate_state ?? 'ongoing',
                    dossier.form_id,
                    null,
                    null,
                    null,
                    null,
                    dossier.plateforme_state,
                    dossier.nb_parts ?? '',
                    dossier.is_physical ?? null,
                    dossier.product_name ?? '',
                    dossier.nature,
                    dossier.manager ?? null,
                    dossier.network ?? null
                  )
                }),
                totalItems: data.total_items
              }
            })
    }

    async getFoldersByIntegrationState(currentPage: number, itemPerPage: number, state: string|null, term: string|null, formId: string|null, sortKey: string, sortDirection: string): Promise<{dossiers: FolderDetail[]|null, totalItems: number}> {
        const params = {
          page: currentPage.toString(),
          itemsPerPage: itemPerPage.toString(),
          searchTerm: term !== null ? term : '',
          integrationState: state !== null ? state : '',
          form: formId !== null ? formId : '',
          sortField: sortKey === 'date' ? 'created_at' : sortKey,
          sortDirection,
        }

        return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/integration-state`, params)
            .then(data => {

                if (!data) {
                    return {dossiers: null, totalItems: 0}
                }

              return {
                dossiers: (data.dossiers).map((dossier) => {
                  return new FolderDetail(
                    dossier.id,
                    dossier.creation_date,
                    dossier.validation_date,
                    dossier.signature_date,
                    dossier.status,
                    dossier.client,
                    dossier.detail,
                    dossier.advisor,
                    dossier.present ?? '',
                    dossier.subscriptionGlobalAmount ?? '',
                    dossier.np_amount ?? null,
                    dossier.usu_amount ?? null,
                    dossier.integrate_state ?? 'ongoing',
                    dossier.form_id,
                    null,
                    null,
                    null,
                    null,
                    dossier.plateforme_state,
                    dossier.nb_parts ?? '',
                    dossier.is_physical ?? null,
                    dossier.product_name ?? '',
                    dossier.nature ?? '',
                    dossier.manager,
                    dossier.network ?? null
                  )
                }),
                totalItems: data.total_items
              }
            })
    }

    async getFoldersByPlateformeState(currentPage: number, itemPerPage: number, state: string | null, term: string | null, formId: string | null, sortKey: string, sortDirection: string): Promise<{ dossiers: FolderDetail[] | null, totalItems: number }> {
      const params = {
        page: currentPage.toString(),
        itemsPerPage: itemPerPage.toString(),
        searchTerm: term !== null ? term : '',
        platformState: state !== null ? state : '',
        form: formId !== null ? formId : '',
        sortField: sortKey === 'date' ? 'created_at' : sortKey,
        sortDirection,
      }

      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/platform-state`, params)
        .then(data => {

          if (!data) {
            return { dossiers: null, totalItems: 0 }
          }

          return {
            dossiers: (data.dossiers).map((dossier) => {
              return new FolderDetail(
                dossier.id,
                dossier.creation_date,
                dossier.validation_date,
                dossier.signature_date,
                dossier.status,
                dossier.client,
                dossier.detail,
                dossier.advisor,
                dossier.present ?? '',
                dossier.subscriptionGlobalAmount ?? '',
                dossier.np_amount ?? null,
                dossier.usu_amount ?? null,
                dossier.integrate_state ?? 'ongoing',
                dossier.form_id,
                null,
                null,
                null,
                null,
                dossier.plateforme_state,
                dossier.nb_parts ?? '0',
                dossier.is_physical ?? null,
                dossier.product_name ?? '',
                dossier.nature ?? '',
                dossier.manager,
                dossier.network ?? null
              )
            }),
            totalItems: data.total_items
          }
        })
    }


    async getFoldersByPreSignatureValidationState(currentPage: number, itemPerPage: number, term: string | null, formId: string | null): Promise<{ dossiers: FolderDetail[] | null, totalItems: number }> {
      const params = {
        page: currentPage.toString(),
        itemsPerPage: itemPerPage.toString(),
        searchTerm: term !== null ? term : '',
        form: formId !== null ? formId : ''
      }

      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/pre-signature-validation`, params)
        .then(data => {

          if (!data) {
            return { dossiers: null, totalItems: 0 }
          }

          return {
            dossiers: (data.dossiers).map((dossier) => {
              return new FolderDetail(
                dossier.id,
                dossier.creation_date,
                dossier.validation_date,
                dossier.signature_date,
                dossier.status,
                dossier.client,
                dossier.detail,
                dossier.advisor,
                dossier.present ?? '',
                dossier.subscriptionGlobalAmount ?? '',
                dossier.np_amount ?? null,
                dossier.usu_amount ?? null,
                dossier.integrate_state ?? 'ongoing',
                dossier.form_id,
                null,
                null,
                null,
                null,
                dossier.plateforme_state,
                '',
                null,
                dossier.product_name ?? '',
                dossier.nature ?? '',
                dossier.manager ?? null,
                dossier.network ?? null
              )
            }),
            totalItems: data.total_items
          }
        })
    }

  async getFolder(folderId: string): Promise<Record<string, unknown> | null> {
    return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/${folderId}`, {})
      .then(dossier => {
        if (!dossier) {
          return null
        }
        return dossier
      })
  }

    async updateFolderStatusToCanceled(folderId: string): Promise<Folder> {
        return await Caller.executePut(
            `${envVariable('REACT_APP_API_URL')}/dossiers/${folderId}/status`,
            {status: 'canceled'}
        )
            .then(
                response => {
                    return new Folder(
                        response.dossier.id,
                        response.dossier.form_id,
                        response.dossier.client_id,
                        response.dossier.advisor_id,
                        response.dossier.last_submitted_block_id,
                        response.dossier.values,
                        response.dossier.direct,
                        response.dossier.receipts,
                        response.dossier.authorized_clients,
                        response.dossier.status
                    )
                }
            )
    }

    async downloadSignedFolderDocument(folderId: string): Promise<Blob> {
        return await Caller.executeGetResponseAsBlob(
            `${envVariable('REACT_APP_API_URL')}/dossier/${folderId}/sign/download`,
            {}
        )
          .then(blob => blob)
          .catch((errors) => Promise.reject(errors))
    }

    async folderDocuSignHistory(folderId: string): Promise<Blob> {
        return await Caller.executeGetResponseAsBlob(
            `${envVariable('REACT_APP_API_URL')}/dossier/${folderId}/sign/history`,
            {}
        )
        .then(
            (blob) => blob
        ).catch(
            (error) => {
                return Promise.reject(error)
            }
        )
    }

    async downloadSignatureProof(folderId: string): Promise<Blob> {
        return await Caller.executeGetResponseAsBlob(
            `${envVariable('REACT_APP_API_URL')}/dossier/${folderId}/sign/signature-proof`,
            {}
        )
          .then(blob => blob)
          .catch((errors) => Promise.reject(errors))
    }

    async retrieveNumberDossiersByState(): Promise<Record<string, number>|null> {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossiers/retrieve-number-dossiers-by-status`, {})
        .then(data => {
          return data ?? null
        })
    }

    async updateDossierIntegrationState(dossierId: string, state: string, reason: string|null|undefined, invalidElements: InvalidElement[]): Promise<boolean> {
      return await Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/integration-state/${dossierId}`, {
        state: state,
        elements: invalidElements
      }).then(() => {
          return true;
        }).catch(() => {
          return false
        })
    }

    async updateDossierPlatformState(dossierId: string, state: string, reason: string|null, invalidElements: InvalidElement[]): Promise<boolean> {
      const params = {
        platform_status: state,
        elements: invalidElements
      }

      if (reason) {
        params['reason'] = reason
      }
      return await Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/platform-state/${dossierId}`, params)
        .then(() => {
          return true;
        }).catch(() => {
          return false
        })
    }

    async retrieveState(dossierId: string): Promise<string|null> {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossier/integration-state/${dossierId}/state`, {})
        .then(data => {
          if (!data) {
            return null
          }

          return data.state
        })
    }

    async retrievePlatformState(dossierId: string): Promise<string|null> {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossier/platform-state/${dossierId}/state`, {})
        .then(data => {
          return data ? data.state : null
        })
    }

    async getSummary(dossierId: string): Promise<FolderDetail|null> {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossier/${dossierId}/summary`, {})
      .then(data => {
          if (!data) {
              return null
          }

          const dossier = data.dossier
          return new FolderDetail(
            dossier.id,
            dossier.creation_date,
            dossier.validation_date,
            dossier.signature_date,
            dossier.status,
            dossier.client,
            dossier.detail,
            dossier.advisor,
            dossier.present ?? '',
            dossier.subscriptionGlobalAmount ?? '',
            dossier.np_amount ?? null,
            dossier.usu_amount ?? null,
            dossier.integrate_state ?? 'ongoing',
            dossier.form_id,
            dossier.detention_mode,
            dossier.dismemberment_type,
            dossier.dismemberment_scope,
            null,
            dossier.plateforme_state,
            dossier.nb_parts,
            dossier.is_physical ?? null
          )
        }
      )
    }

    async getPairing(dossierId: string): Promise<PairingInterface|null> {
      return await Caller.executeGet(`${envVariable('REACT_APP_API_URL')}/dossier/integration-state/${dossierId}/pairing`, {})
        .then(data => {
          if (!data) {
            return null
          }

          return new Pairing(
            data.pairing,
            data.forceMandate
          );
        })
    }

    async duplicateFolder(folderId: string, documentDuplicate: boolean): Promise<Folder | null> {
      return Caller.executePost(`${envVariable('REACT_APP_API_URL')}/dossiers/${folderId}/duplicate`, {
        'documentDuplicate': documentDuplicate
      })
        .then(
          response => {
            if (!response) {
              return null
            }

            return new Folder(
              response.dossier.id,
              response.dossier.form_id,
              response.dossier.client_id,
              response.dossier.advisor_id,
              response.dossier.last_submitted_block_id,
              response.dossier.values,
              response.dossier.direct,
              response.dossier.receipts,
              response.dossier.authorized_clients,
              response.dossier.status
            )
          }
        )
    }

    async forceValidateFolder(folderId: string): Promise<Folder | null> {
      return Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/platform-state/${folderId}`, {
        'platform_status': 'validated'
      })
        .then(
          response => {
            if (!response) {
              return null
            }
            return response
          }
        )
    }

    async updateDossierSubmitPreSignatureValidationStatus(dossierId: string, state: string, reason: string|null|undefined, invalidElements: InvalidElement[]): Promise<boolean> {
      const params = {
        status: state,
        elements: invalidElements
      }

      if (reason) {
        params['reason'] = reason
      }
      return await Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossiers/pre-signature-validation/${dossierId}`, params)
        .then(() => {
          return true
        }).catch(() => {
          return false
        })
    }


  async askSubscriberToCorrect(folderId?: string): Promise<string | null> {
    const effectiveFolderId = folderId ?? getFolderIdFromUrl() ?? storage.getFolderId();
    return Caller.executePost(`${envVariable('REACT_APP_API_URL')}/dossier/${effectiveFolderId}/ask-subscriber-correct`, {})
      .then(
        response => {
          return response ? response : null
        }
      )
  }

  async modifyFolderWaitingSign(folderId: string): Promise<Folder | null> {
      return Caller.executePut(`${envVariable('REACT_APP_API_URL')}/dossier/${folderId}/modify-dossier-waiting-sign`, {})
        .then(
          response => {
            return response ? response : null
          }
        )
    }
}
